// test1730
(1730 && 0);
